import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-6 mb-xl-9 pt-0 pb-0"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-6 d-flex justify-content-start" }
const _hoisted_7 = { class: "col-md-6 d-flex justify-content-end" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Flags:", -1)
const _hoisted_9 = { class: "card-title mt-5" }
const _hoisted_10 = { class: "progress col-md-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 1,
  class: "row d-flex justify-content-between mx-1"
}
const _hoisted_13 = { class: "card mb-6 col-md-5 mb-xl-9 pt-0 pb-0" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "flex-grow-1" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-9 d-flex justify-content-start" }
const _hoisted_19 = { class: "col-md-3 d-flex justify-content-end" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("b", null, "Flags:", -1)
const _hoisted_21 = { class: "card-title mt-5" }
const _hoisted_22 = { class: "progress col-md-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = { class: "card mb-6 col-md-5 mb-xl-9 pt-0 pb-0" }
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = { class: "card-title" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-12 d-flex justify-content-start" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-pdf-fill fs-2" }, null, -1)
const _hoisted_30 = { class: "overflow-auto pb-5" }
const _hoisted_31 = { class: "d-flex align-items-center border border-dashed border-gray-300 rounded p-5" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = {
  key: 0,
  alt: "",
  class: "w-30px me-3",
  src: "/media/svg/files/upload.svg"
}
const _hoisted_34 = {
  key: 1,
  alt: "",
  class: "w-30px me-3",
  src: "/media/svg/files/pdf.svg"
}
const _hoisted_35 = { class: "ms-1 fw-bold" }
const _hoisted_36 = ["href"]
const _hoisted_37 = { class: "text-gray-400" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "d-flex flex-aligns-center pe-10 pe-lg-20" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  class: "w-30px me-3",
  src: "/media/svg/files/pdf.svg"
}, null, -1)
const _hoisted_41 = { class: "ms-1 fw-bold" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("a", {
  style: {"cursor":"not-allowed"},
  class: "fs-6 text-hover-primary fw-bolder"
}, "Write-UP", -1)
const _hoisted_43 = { class: "text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.machine.type == 'default')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.your_progress_on_this_machine_is`)) + ": ", 1),
                    _createTextVNode("  " + _toDisplayString(_ctx.percentage) + "% ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createTextVNode("  " + _toDisplayString(parseFloat(((_ctx.percentage / 100) * _ctx.machine.total_flags).toString()).toFixed(0)) + "/" + _toDisplayString(_ctx.machine.total_flags), 1)
                  ])
                ]),
                _createElementVNode("h6", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", {
                      class: "progress-value",
                      style: _normalizeStyle('width: ' + _ctx.percentage + '%')
                    }, null, 4)
                  ]),
                  _hoisted_11
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.your_progress_on_this_machine_is`)) + ": ", 1),
                      _createTextVNode("  " + _toDisplayString(_ctx.percentage) + "% ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createTextVNode("  " + _toDisplayString(parseFloat(((_ctx.percentage / 100) * _ctx.machine.total_flags).toString()).toFixed(0)) + "/" + _toDisplayString(_ctx.machine.total_flags), 1)
                    ])
                  ]),
                  _createElementVNode("h6", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", {
                        class: "progress-value",
                        style: _normalizeStyle('width: ' + _ctx.percentage + '%')
                      }, null, 4)
                    ]),
                    _hoisted_23
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.common.attachments`)), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  (_ctx.machine.attachments)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.machine.attachments, (attachment) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "d-flex flex-aligns-center pe-10 pe-lg-20",
                            key: attachment
                          }, [
                            (attachment.type == 'link')
                              ? (_openBlock(), _createElementBlock("img", _hoisted_33))
                              : (_openBlock(), _createElementBlock("img", _hoisted_34)),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("a", {
                                href: attachment.url,
                                target: "_blank",
                                class: "fs-6 text-hover-primary fw-bolder"
                              }, _toDisplayString(attachment.name), 9, _hoisted_36),
                              _createElementVNode("div", _hoisted_37, _toDisplayString(attachment.filename), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createElementVNode("div", _hoisted_41, [
                            _hoisted_42,
                            _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.$t(`${_ctx.currentLanguage}.machine.available_only_for_members`)), 1)
                          ])
                        ])
                      ]))
                ])
              ])
            ])
          ])
        ]))
  ]))
}